import html5 from "../../assets/technologies/html.svg"; //1
import css3 from "../../assets/technologies/css.svg"; //2
import javascript from "../../assets/technologies/javascript.svg"; //3
import reactjs from "../../assets/technologies/react.svg"; //4
import styledComponents from "../../assets/technologies/styled-components.svg"; //5
import bootstrap from "../../assets/technologies/bootstrap.svg"; //6
import npm from "../../assets/technologies/npm.svg"; //7
import git from "../../assets/technologies/git.svg"; //8
import github from "../../assets/technologies/github.svg";
import vscode from "../../assets/technologies/visual-studio-code.svg"; //9
import mongodb from "../../assets/technologies/mongodb.svg"; //10
import materialui from "../../assets/technologies/materialui.svg"; //11
import chakraui from "../../assets/technologies/chakraui.svg"; //12
import nodejs from "../../assets/technologies/nodejs.svg"; //13
import nextjs from "../../assets/technologies/nextjs.svg"; //16
import firebase from "../../assets/technologies/firebase.svg"; //17
import java from "../../assets/technologies/java.svg"; //18
import springboot from "../../assets/technologies/springboot.svg"; //19
import mysql from "../../assets/technologies/mysql.svg"; //20

export const iconsData = [
  {
    id: 1,
    icon: html5,
    name: "HTML5",
  },
  {
    id: 2,
    icon: css3,
    name: "CSS3",
  },
  {
    id: 3,
    icon: javascript,
    name: "JavaScript",
  },
  {
    id: 18,
    icon: java,
    name: "Java",
  },
  {
    id: 20,
    icon: mysql,
    name: "MySQL",
  },
  {
    id: 4,
    icon: reactjs,
    name: "React JS",
  },
  {
    id: 6,
    icon: nextjs,
    name: "Next JS",
  },
  {
    id: 7,
    icon: nodejs,
    name: "Node.js",
  },
  {
    id: 19,
    icon: springboot,
    name: "Spring Boot",
  },
  {
    id: 10,
    icon: chakraui,
    name: "Chakra-UI",
  },
  {
    id: 11,
    icon: bootstrap,
    name: "Bootstrap",
  },
  {
    id: 12,
    icon: materialui,
    name: "Material UI",
  },
  {
    id: 14,
    icon: styledComponents,
    name: "Styled Components",
  },
  {
    id: 9,
    icon: firebase,
    name: "Firebase",
  },
  {
    id: 8,
    icon: git,
    name: "Git",
  },
  {
    id: 13,
    icon: mongodb,
    name: "MongoDB",
  },
];
